import { useMemo } from "react";
import boardData from "@/data/emailZeroWall.json";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import ZeroWall from "./ZeroWall";

// The zero-inbox wall — /email/board.
//
// The numbers come from the one data module the script-only ingest writes
// (emailZeroBoard.json). The differential gate asserts that file is a
// byte-identical copy of the payload it recomputed from the sources, so the
// board can never show a number nobody checked.
//
// The wall is a plain read — no LLM, no live write path, no archive actions.
//
// WHERE THIS LIVES: moved here from the chunk's build dir
// (SYSTEM/kit-os/GOALS/email-zero-inbox/build/) 2026-11-02; the route
// "/email/board" mounts <EmailZeroWallPage /> via App.js (an explicit Route,
// ahead of the registry WallShell so the built wall is what /email/board
// mounts) and the registry's email entry keeps the parallel lane's
// ZeroWallPage as the shell's Bare export.
export default function EmailZeroWallPage() {
  const desktop = useMediaQuery("(min-width: 1024px)");
  const payload = useMemo(() => boardData, []);

  return (
    <div data-testid="email-zero-wall-page" className="w-full font-inter text-os-ink">
      <div
        className={
          desktop
            ? "mx-auto flex max-w-[100rem] flex-col gap-4 px-10 py-6"
            : "flex flex-col gap-3 px-4 pb-8 pt-4"
        }
      >
        <ZeroWall payload={payload} />
      </div>
    </div>
  );
}